import React from "react";
import { Card, InlineStack, Box, Text, BlockStack } from "@shopify/polaris";

/**
 * Stats Overview Cards
 * Displays high-level statistics about video conversion status
 */
const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      label: "Total Videos",
      value: stats.total,
      color: "#5C6AC4",
      icon: "📹",
    },
    {
      label: "HLS Videos",
      value: stats.hls,
      percentage: stats.hlsPercentage,
      color: "#50B83C",
      icon: "✅",
    },
    {
      label: "MP4 Videos",
      value: stats.mp4,
      percentage: stats.mp4Percentage,
      color: "#006FBB",
      icon: "⚠️",
    },
    {
      label: "Converting",
      value: stats.converting,
      percentage: stats.convertingPercentage,
      color: "#FFC453",
      icon: "⟳",
    },
  ];

  return (
    <InlineStack gap="4" wrap={false}>
      {statCards.map((stat, index) => (
        <div key={index} style={{ flex: 1, minWidth: "200px" }}>
          <Card>
            <Box padding="4">
              <BlockStack gap="2">
                <InlineStack align="space-between" blockAlign="center">
                  <Text as="h3" variant="headingMd" tone="subdued">
                    {stat.label}
                  </Text>
                  <Text as="span" variant="headingLg">
                    {stat.icon}
                  </Text>
                </InlineStack>

                <Text as="p" variant="heading2xl" fontWeight="bold">
                  {stat.value.toLocaleString()}
                </Text>

                {stat.percentage !== undefined && (
                  <Text as="p" variant="bodyMd" tone="subdued">
                    {stat.percentage}%
                  </Text>
                )}
              </BlockStack>
            </Box>

            {/* Color indicator bar */}
            <div
              style={{
                height: "4px",
                backgroundColor: stat.color,
                marginTop: "12px",
              }}
            />
          </Card>
        </div>
      ))}
    </InlineStack>
  );
};

export default StatsOverview;